/*
    SUMMARY
    0 - AUTO YEAR
    1 - BACK TO TOP
*/


export default function Footer() {

    /*-----------------/ 0 - Const / Variables /--------------------*/

    const btnMobileGoTop = document.querySelector('.btn-mobile-go-top')

    /*-----------------/ 1 - Function /--------------------*/


    /*-----------------/ 2 - Event /--------------------*/
    btnMobileGoTop.addEventListener('click', (e) => {
        e.preventDefault()
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            block: 'start'
        })
    })


}